import { Api } from "../config/request";

export default {
    bulkUploadDriverSecondaryLocality(payload) {
        return Api.post("/driver-locality/secondary-mapping-bulk-upload", payload);
    },
};